import {useEffect} from 'react'

import EditForm from './EditForm.js'
import NewForm from './NewForm.js'
import {useSelector} from '../../../store.js'
import {
  resetUsersForm,
  settingsUserAddSelector,
  settingsUserIDSelector,
  setupForAdding,
  setupForEdit,
} from './usersFunctions.js'
import {activeUsersSortedByNameSelector} from '../../../data/users.js'
import {canManageUserPermissionSelector} from '../../../data/me.js'

export default function List() {
  const users = useSelector(activeUsersSortedByNameSelector)
  const canManageUser = useSelector(canManageUserPermissionSelector)
  const settingsUserID = useSelector(settingsUserIDSelector)

  useEffect(() => {
    if (!settingsUserID) {
      return
    }

    setupForEdit()
  }, [settingsUserID])

  const settingsUserAdd = useSelector(settingsUserAddSelector)
  useEffect(() => {
    if (!settingsUserAdd) {
      return
    }

    setupForAdding()
  }, [settingsUserAdd])

  useEffect(() => {
    if (settingsUserID || settingsUserAdd) {
      return
    }

    resetUsersForm()
  }, [settingsUserID, settingsUserAdd])

  return (
    <ul className="settings-list medium-12 columns">
      {users.map((user) => (
        <EditForm key={user.id} user={user} />
      ))}
      {canManageUser && <NewForm />}
    </ul>
  )
}
